<template>
    <div class="container-md container-app p-0 ">
        <div class="wrapper">
            <div class="header-menu">
                <router-link :to="{name:'menu.categories'}">
                    <h1 class="text-left pull-left">{{$t('menu')}}</h1>
                </router-link>
                <div class="clearfix"></div>
            </div>
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Index"
    }
</script>
